import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { TextFieldAccordionFilterErrorProps as Props } from './types';

export const TextFieldAccordionFilterError = memo(
  ({ className, text }: Props) => {
    return (
      <Box
        className={classnames('TextFieldAccordionFilterError', className)}
        display={'flex'}
        alignItems={'center'}
        paddingX={1}
        sx={SX.root}
      >
        <Typography variant="body5" color="error" children={text} />
      </Box>
    );
  }
);

TextFieldAccordionFilterError.displayName = 'TextFieldAccordionFilterError';
